import React from "react";
import { FiTruck, FiUserCheck, FiPackage } from "react-icons/fi";
import { miladiToShamsi } from "../../utils/miladiToShamsi";

const shippingLabels = {
  carrier: { label: "حمل توسط باربری", icon: <FiTruck className="w-5 h-5" /> },
  supplier: { label: "ارسال تأمین‌کننده", icon: <FiUserCheck className="w-5 h-5" /> },
  pickup: { label: "تحویل حضوری", icon: <FiUserCheck className="w-5 h-5" /> },
};

export default function ShippingMethodCard({
  method,
  isSelected,
  disabled,
  onClick,
}) {
  const methodInfo = shippingLabels[method.method] || {
    label: method.method,
    icon: <FiPackage className="w-5 h-5" />,
  };

  return (

        <button
            type="button"
            disabled={disabled}
            onClick={onClick}
            className={`flex items-center justify-between p-3 rounded-lg border-2 text-right transition-all ${
                isSelected
                    ? "border-blue-600 bg-white shadow-md text-blue-700 font-semibold"
                    : "border-gray-200 bg-white text-gray-600 hover:border-blue-300"
            } ${
                disabled
                    ? "opacity-50 cursor-not-allowed bg-gray-100 hover:border-gray-200"
                    : ""
            }`}
        >
          <div className="flex flex-col text-sm gap-1.5 w-full">
            {/* عنوان و آیکون */}
            <div className="flex items-center gap-2 text-gray-800">
              <span className="text-blue-600">{methodInfo.icon}</span>
              <span className="font-bold">{methodInfo.label}</span>
            </div>

            {/* هزینه */}
            <div className="flex items-center gap-1 text-xs text-gray-500">
              <span>هزینه ارسال:</span>
              <span className="font-semibold">
            {method.calculated_delivery_cost === "0"
                ? "رایگان"
                : `${Number(method.calculated_delivery_cost).toLocaleString("fa-IR")} تومان`}
          </span>
            </div>

            {/* تاریخ تحویل */}
            <div className="flex items-center gap-1 text-xs text-gray-500">
              <span>زمان تحویل تقریبی:</span>
              <span className="font-semibold">
            {method.estimated_delivery_date
                ? miladiToShamsi(method.estimated_delivery_date)
                : "نامشخص"}
          </span>
            </div>

            {disabled && (
                <div className="text-[11px] text-red-500 mt-1 font-medium">
                  ابتدا آدرس تحویل را انتخاب کنید
                </div>
            )}
          </div>

          {isSelected && (
              <div className="w-5 h-5 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mr-2">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>
          )}
        </button>
  );
}
